module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADgSURBVHgBjVOBEcIgDAxOwAhsoBvYEXQDR+gGMoIbOAIjgBO0G0gnqBtg0FCRAuXvcrnjyeeBwKAA59wBU4fBMQxjzEALsJBjKLfGk0Q3BXRUIDH6SHDGELXiS1TME04Sp2sCoVNX4GfiF/FdsicQFvIYk30rgYmyKAiE9VeWRWsnsjhk7uBK3B1qKLyCbnqFpFMOOhVgUaG3rOA7fR4G4wG/sx8pW4wzTuaYdlbR+UXBncwepTZAFREdLw60uD3r8HfRInyej3VoBL2MR+8HKXSdoB2W8j44uLXaJwdLzRsYulOKnodEJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/icon-user.png
// module id = dZ8j
// module chunks = 0